import {
  Button,
  Td,
  Tr,
  useToast,
} from "@chakra-ui/react";
import React from "react";
import {useMutation, useQueryClient} from "react-query";

import {postCandidateSetActive} from "../../shared/Api";
import {errorToast} from "../../shared/helper/ToastHelper";
import {CandidateStatus} from "../../shared/model/Constants";
import {CandidateSummaryDto} from "../../shared/model/Dto";
import {adminKeys} from "../../shared/QueryKeys";
import {displayCandidateStatus, displayTime} from "../../shared/Utils";

type CandidateSummaryItemProps = {
  candidateSummary: CandidateSummaryDto;
};
const EDICandidateSummaryItem = (props: CandidateSummaryItemProps) => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const setCandidateActive = useMutation(
    ({publicId, candidateToken, active, type, isAutomated}: any) =>
      postCandidateSetActive(props.candidateSummary.username, publicId, candidateToken, active,
          type, isAutomated),
    {
      onSuccess: (data, variables) => {
        if (variables.type==="reading")
          props.candidateSummary.candidateR.active = variables.active;
        else
        if (variables.type==="speaking")
          props.candidateSummary.candidateS.active = variables.active;
        else
          props.candidateSummary.candidateL.active = variables.active;
        //successToast(toast, "Candidato actualizado");
        return queryClient.invalidateQueries(adminKeys.candidateActive());
      },
      onError: () => {
        errorToast(toast, "Error actualizando candidato");
      },
    });

  const institution = props.candidateSummary.institution !== null ? props.candidateSummary.institution : "";
  const region = props.candidateSummary.region !== null ? props.candidateSummary.region : "";
  const institutionDisplay = institution && region ? institution+" - "+region : institution+region

  // Rerender to make sure active is updated
  // noinspection SillyAssignmentJS
  props.candidateSummary.candidateR.active = props.candidateSummary.candidateR.active;
  // noinspection SillyAssignmentJS
  props.candidateSummary.candidateL.active = props.candidateSummary.candidateL.active;
  // noinspection SillyAssignmentJS
  props.candidateSummary.candidateS.active = props.candidateSummary.candidateS.active;
  return (
    <>
      <Tr key={props.candidateSummary.candidateR.token +" "+ props.candidateSummary.candidateL.token
        +" "+ props.candidateSummary.candidateS.test}>
        <Td>{props.candidateSummary.username}</Td>
        <Td>{props.candidateSummary.name}</Td>
        <Td>{institutionDisplay}</Td>
        <Td>{props.candidateSummary.userGroup}</Td>

        <Td>{displayCandidateStatus(props.candidateSummary.candidateR.status)}</Td>
        <Td>{displayTime(props.candidateSummary.candidateR.startTime)}</Td>
        <Td>{displayTime(props.candidateSummary.candidateR.endTime)}</Td>
        <Td>{props.candidateSummary.candidateR.lastAnsweredQuestion}</Td>
        <Td>
          {props.candidateSummary.candidateR.status !== CandidateStatus.TEST_COMPLETE &&
            props.candidateSummary.candidateR.status !== null &&
            props.candidateSummary.candidateR.active &&
            <Button onClick={()=>setCandidateActive.mutate({
              publicId: props.candidateSummary.candidateR.test,
              candidateToken: props.candidateSummary.candidateR.token,
              active: false, type:"reading", isAutomated:false
            })} colorScheme='red'
                    isLoading={setCandidateActive.isLoading} >
              Deshabilitar
            </Button>
          } {props.candidateSummary.candidateR.status !== CandidateStatus.TEST_COMPLETE &&
          props.candidateSummary.candidateR.status !== null &&
          !props.candidateSummary.candidateR.active &&
          <Button onClick={()=>setCandidateActive.mutate({
            publicId: props.candidateSummary.candidateR.test,
            candidateToken: props.candidateSummary.candidateR.token,
            active: true, type:"reading", isAutomated:false
          })} colorScheme='green'
                  isLoading={setCandidateActive.isLoading} >
            Habilitar
          </Button>
          }
        </Td>
        <Td>{displayCandidateStatus(props.candidateSummary.candidateL.status)}</Td>
        <Td>{displayTime(props.candidateSummary.candidateL.startTime)}</Td>
        <Td>{displayTime(props.candidateSummary.candidateL.endTime)}</Td>
        <Td>{props.candidateSummary.candidateL.lastAnsweredQuestion}</Td>
        <Td>
          {props.candidateSummary.candidateL.status !== CandidateStatus.TEST_COMPLETE &&
            props.candidateSummary.candidateL.status !== null &&
            props.candidateSummary.candidateL.active &&
            <Button onClick={()=>setCandidateActive.mutate({
              publicId: props.candidateSummary.candidateL.test,
              candidateToken: props.candidateSummary.candidateL.token,
              active: false, type:"listening", isAutomated:false
            })} colorScheme='red'
                    isLoading={setCandidateActive.isLoading} >
              Deshabilitar
            </Button>
          } {props.candidateSummary.candidateL.status !== CandidateStatus.TEST_COMPLETE &&
          props.candidateSummary.candidateL.status !== null &&
          !props.candidateSummary.candidateL.active &&
          <Button onClick={()=>setCandidateActive.mutate({
            publicId: props.candidateSummary.candidateL.test,
            candidateToken: props.candidateSummary.candidateL.token,
            active: true, type:"listening", isAutomated:false
          })} colorScheme='green'
                  isLoading={setCandidateActive.isLoading} >
            Habilitar
          </Button>
        }
        </Td>
        <Td>{displayCandidateStatus(props.candidateSummary.candidateS.status)}</Td>
        <Td>{displayTime(props.candidateSummary.candidateS.startTime)}</Td>
        <Td>{displayTime(props.candidateSummary.candidateS.endTime)}</Td>
        <Td>
          {props.candidateSummary.candidateS.status !== CandidateStatus.TEST_COMPLETE &&
            props.candidateSummary.candidateS.status !== null &&
            props.candidateSummary.candidateS.active &&
            <Button onClick={()=>setCandidateActive.mutate({
              publicId: props.candidateSummary.candidateS.test,
              candidateToken: props.candidateSummary.candidateS.test,
              active: false, type:"speaking", isAutomated:true
            })} colorScheme='red'
                    isLoading={setCandidateActive.isLoading} >
              Deshabilitar
            </Button>
          } {props.candidateSummary.candidateS.status !== CandidateStatus.TEST_COMPLETE &&
          props.candidateSummary.candidateS.status !== null &&
          !props.candidateSummary.candidateS.active &&
          <Button onClick={()=>setCandidateActive.mutate({
            publicId: props.candidateSummary.candidateS.test,
            candidateToken: props.candidateSummary.candidateS.test,
            active: true, type:"speaking", isAutomated:true
          })} colorScheme='green'
                  isLoading={setCandidateActive.isLoading} >
            Habilitar
          </Button>
        }
        </Td>
      </Tr>

    </>
  );
};
export default EDICandidateSummaryItem;